import { render, staticRenderFns } from "./live.vue?vue&type=template&id=482bbd5d&scoped=true"
import script from "./live.vue?vue&type=script&lang=js"
export * from "./live.vue?vue&type=script&lang=js"
import style0 from "./live.vue?vue&type=style&index=0&id=482bbd5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482bbd5d",
  null
  
)

export default component.exports